import { render } from "./App.vue?vue&type=template&id=23c2013b&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=23c2013b&scoped=true&lang=scss"
import "./App.vue?vue&type=style&index=1&id=23c2013b&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c2013b"]])

export default __exports__